module.exports = __webpack_public_path__ + "static/media/hr.ba47c14c.svg";